// =============================================================================
// src/features/explore/mini-hint.ts — Toast efemero da tela Explorar (#expHint).
//
// Proveniencia: assets/explore.js `function MiniHint` (linhas 655-660). Portado
//   FIEL: cria o #expHint sob #u-explore-page (ou body) na primeira chamada, mostra
//   a classe `.show` e a remove apos 2200ms (constraint de paridade — NAO alterar).
//   O timer e debounced: cada chamada reinicia a contagem (clearTimeout do anterior).
//
// SRP: so o toast. Sem dados, sem mapa. Nome greppavel `showMiniHint` no lugar do
//   `MiniHint` legado (que carregava o timer como propriedade da funcao).
// =============================================================================

import { qs } from '../../app/dom';

/** Duracao do toast antes de sumir (assets/explore.js linha 659) — paridade. */
const MINI_HINT_VISIBLE_MS = 2200;
/** Id do container da rota (host preferencial do toast). */
const EXPLORE_PAGE_ID = 'u-explore-page';

/** Handle do timer de ocultacao (modulo-escopo; debounce entre chamadas). */
let hideTimer: ReturnType<typeof setTimeout> | undefined;

/** Resolve (criando uma vez) o elemento #expHint, ancorado na pagina Explorar. */
function ensureHintElement(): HTMLElement {
  const existing = qs<HTMLElement>('#expHint');
  if (existing) return existing;
  const hint = document.createElement('div');
  hint.id = 'expHint';
  hint.className = 'exp-hint';
  (qs<HTMLElement>(`#${EXPLORE_PAGE_ID}`) ?? document.body).appendChild(hint);
  return hint;
}

/**
 * Exibe uma dica efemera (ex.: "Sem resultados para …") e a esconde em 2200ms.
 * Reinicia o timer a cada chamada para que a ultima mensagem permaneca o periodo cheio.
 *
 * @example
 *   showMiniHint('Sem resultados para "Tefé"');
 */
export function showMiniHint(message: string): void {
  const hint = ensureHintElement();
  hint.textContent = message;
  hint.classList.add('show');
  clearTimeout(hideTimer);
  hideTimer = setTimeout(() => hint.classList.remove('show'), MINI_HINT_VISIBLE_MS);
}
